module.exports = __webpack_public_path__ + "img/3.2088f0ce.jpg";